<div class="filter_dd_multiselect" (clickOutside)="close()">
  <div (click)="toogle()">
    {{field.label}} <span class="d-arrow"><i class="fas fa-chevron-down"></i></span>
  </div>
  <ul class="filter-list multiselect_list" [perfectScrollbar]="config" [ngClass]="{'d-block':open}">
    <li *ngFor="let item of field.options">
      <a [routerLink]="[item.link | removeSpace]" [queryParams]="item.queryParams || {}"> {{item.name}}</a>
    </li>
  </ul>
</div>